"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Spanish localization
 */
exports.default = {
    didNotBackUpWallet: "Si no respaldaste tu certificado o perdiste tu teléfono, contacta al soporte @TicketheadSupport.",
    nft: 'Head',
};
//# sourceMappingURL=es.js.map